// extracted by mini-css-extract-plugin
export var promotionLink = "_wd-0";